import {
    ActionType,
    getDetectionConfigAction,
    getDetectionThresholdAction,
    updateDetectionConfigAction
} from "./actions";
import { DetectionConfigJson, detectionConfigInitialState as configInitialState } from "../../../domain/detection/config/DetectionConfig";
import { DetectionThresholdJson } from "../../../domain/detection/config/DetectionThreshold";
import { createSlice } from "@reduxjs/toolkit";

export type DetectionConfigState = Readonly<{
    config: DetectionConfigJson,
    threshold: DetectionThresholdJson | undefined,
    updateProcess: number,
    getConfigProcess: boolean,
    getThresholdProcess: boolean
}>;

const detectionConfigInitialState: DetectionConfigState = {
    config: configInitialState,
    threshold: undefined,
    updateProcess: 0,
    getConfigProcess: false,
    getThresholdProcess: false
};

const slice = createSlice({
    name: ActionType.base,
    initialState: detectionConfigInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(
                getDetectionConfigAction.pending,
                (state) => {
                    state.config =  configInitialState;
                    state.getConfigProcess = true;
                }
            )
            .addCase(
                getDetectionConfigAction.fulfilled,
                (state, action) => {
                    const { payload } = action;
                    const { config } = payload;
                    state.config = config;
                    state.getConfigProcess = false;
                }
            )
            .addCase(
                getDetectionConfigAction.rejected,
                (state) => {
                    state.getConfigProcess = false;
                }
            )
            .addCase(
                getDetectionThresholdAction.pending,
                (state) => {
                    state.threshold = undefined;
                    state.getThresholdProcess = true;
                }
            )
            .addCase(
                getDetectionThresholdAction.fulfilled,
                (state, action) => {
                    const { payload } = action;
                    const { threshold } = payload;
                    state.threshold = threshold;
                    state.getThresholdProcess = false;
                }
            )
            .addCase(
                getDetectionThresholdAction.rejected,
                (state) => {
                    state.getThresholdProcess = false;
                }
            )
            .addCase(
                updateDetectionConfigAction.pending,
                (state) => {
                    state.updateProcess += 1;
                }
            )
            .addCase(
                updateDetectionConfigAction.fulfilled,
                (state) => {
                    state.updateProcess -= 1;
                }
            )
            .addCase(
                updateDetectionConfigAction.rejected,
                (state) => {
                    state.updateProcess -= 1;
                }
            );
    }
});

export const detectionConfigReducer = slice.reducer; 
